<template>
	<v-autocomplete
		:items="items"
		:label="label"
		:disabled="disabled"
		:multiple="multiple"
		:value="selected"
		:clearable="clearable"
		:error-count="3"
		:error-messages="errors || []"
		autocomplete="new-password"
		item-text="name"
		:item-value="itemValue"
		@input="onInput($event)"
		@change="onChange($event)"
	/>
</template>

<script>
import countries from '@/datasources/countries'

export default {
	props: {
		errors: {
			type: Array,
			default: () => [],
		},
		preferred: {
			type: Array,
			default: () => [],
		},
		disabled: Boolean,
		label: String,
		value: [String, Array],
		clearable: Boolean,
		multiple: Boolean,
		useId: Boolean,
		useAlpha3: Boolean,
	},
	data() {
		return {
			items: [],
		}
	},
	computed: {
		selected() {
			return this.value
		},
		itemValue() {
			if (this.useId) {
				return 'id'
			}
			if (this.useAlpha3) {
				return 'alpha3'
			}

			return 'code'
		},
	},
	mounted() {
		this.buildItems()
	},
	methods: {
		onInput(event) {
			this.$emit('input', event)
		},
		onChange(event) {
			this.$emit('change', event)
		},
		buildItems() {
			const items = []
			if (this.preferred.length) {
				items.push({ header: 'Preferred' })
				this.preferred.forEach((code) => {
					const found = countries.find(country => country.code === code)

					if (found) {
						items.push(found)
					}
				})
				items.push({ divider: true })
				items.push({ header: 'All' })
			}

			this.items = [...items, ...countries]
		},
	},
}
</script>
